const INITIAL_STATE = {
  data: {},
  errors: {},
              
}
const getQuickbooksSync = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_QUICKBOOKS_SYNC_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_QUICKBOOKS_SYNC_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
              
export default getQuickbooksSync;